import React, { useState } from "react";
import styled from "@emotion/styled";

const Accordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <AccordionWrapper>
      {items.map((item, index) => (
        <AccordionItem key={index}>
          <AccordionHeader
            onClick={() => toggleAccordion(index)}
            isOpen={openIndex === index}
          >
            <IconWrapper>
              {openIndex === index ? (
                <CloseIcon
                  viewBox="0 0 13 14"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.4766 2.35156L7.78906 7.03906L12.4375 11.6875C12.8281 12.0391 12.8281 12.625 12.4375 12.9766C12.0859 13.3672 11.5 13.3672 11.1484 12.9766L6.46094 8.32812L1.8125 12.9766C1.46094 13.3672 0.875 13.3672 0.523438 12.9766C0.132812 12.625 0.132812 12.0391 0.523438 11.6484L5.17188 7L0.523438 2.35156C0.132812 2 0.132812 1.41406 0.523438 1.02344C0.875 0.671875 1.46094 0.671875 1.85156 1.02344L6.5 5.71094L11.1484 1.0625C11.5 0.671875 12.0859 0.671875 12.4766 1.0625C12.8281 1.41406 12.8281 2 12.4766 2.35156Z"
                    fill="currentColor"
                  />
                </CloseIcon>
              ) : (
                <PlusIcon
                  viewBox="0 0 17 18"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.6875 1.8125V8.0625H15.9375C16.4453 8.0625 16.875 8.49219 16.875 9C16.875 9.54688 16.4453 9.9375 15.9375 9.9375H9.6875V16.1875C9.6875 16.7344 9.25781 17.125 8.75 17.125C8.20312 17.125 7.8125 16.7344 7.8125 16.1875V9.9375H1.5625C1.01562 9.9375 0.625 9.54688 0.625 9C0.625 8.49219 1.01562 8.0625 1.5625 8.0625H7.8125V1.8125C7.8125 1.30469 8.20312 0.875 8.75 0.875C9.25781 0.875 9.6875 1.30469 9.6875 1.8125Z"
                    fill="currentColor"
                  />
                </PlusIcon>
              )}
            </IconWrapper>
            <Title>{item.question}</Title>
          </AccordionHeader>
          <AccordionContent
            isOpen={openIndex === index}
            aria-hidden={openIndex !== index}
          >
            <ContentWrapper>
              <Description>{item.answer}</Description>
            </ContentWrapper>
          </AccordionContent>
        </AccordionItem>
      ))}
    </AccordionWrapper>
  );
};

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  gap: 8px;

`;

const AccordionItem = styled.div`
  border-radius: 8px;
  background: transparent;
  overflow: hidden;
  transition: all 0.3s ease;
`;

const AccordionHeader = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  background: none;
  border: none;
  cursor: pointer;
  gap: 8px;
  transition: all 0.3s ease;
  @media (max-width: 768px) {
    padding: 8px 16px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: rgb(33, 37, 67);
  flex-shrink: 0;
`;

const PlusIcon = styled.svg`
  width: 17px;
  height: 18px;
`;

const CloseIcon = styled.svg`
  width: 13px;
  height: 14px;
`;

const Title = styled.span`
  color: rgb(33, 37, 67);
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const AccordionContent = styled.div`
  max-height: ${(props) => (props.isOpen ? "1000px" : "0")};
  opacity: ${(props) => (props.isOpen ? "1" : "0")};
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  padding: ${(props) => (props.isOpen ? "0 16px 16px 44px" : "0 16px 0 44px")};
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

const Description = styled.p`
  color: rgb(33, 37, 67);
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export default Accordion;
